/* Nwidea — White Novembre 2026. Surcouche de campagne.
   Sur les gabarits pack, EasySell pose son dégradé émeraude et un radius de 12px
   en style inline !important : ni la CSS du thème ni un !important d'auteur ne
   peuvent l'écraser, seul JS le peut. La PDP standard, elle, est déjà traitée
   par nwidea-product-info.liquid + la redéfinition de --nw-accent dans
   nwidea-wf.css — ne pas la cibler ici, les deux scripts se battraient. */
(function () {
  var SEL = '.nwpk .nwpk__form #es-popup-button, .nwpk .nwpk__form .es-popup-button';
  var GREEN = 'var(--nw-cod, #15803D)';

  function restyle(btn) {
    var s = btn.style;
    if (s.getPropertyValue('border-radius').trim() === '0' &&
        s.getPropertyValue('background').indexOf('nw-cod') !== -1) return;
    s.setProperty('background', GREEN, 'important');
    s.setProperty('color', '#fff', 'important');
    s.setProperty('border', '1px solid ' + GREEN, 'important');
    s.setProperty('border-radius', '0', 'important');
    s.setProperty('box-shadow', 'none', 'important');
    s.setProperty('font-family', 'var(--nw-sans, Inter, sans-serif)', 'important');
    s.setProperty('font-weight', '600', 'important');
    s.setProperty('font-size', '12px', 'important');
    s.setProperty('letter-spacing', '.18em', 'important');
    s.setProperty('text-transform', 'uppercase', 'important');
  }

  var seen = new WeakSet();
  function scan() {
    document.querySelectorAll(SEL).forEach(function (btn) {
      if (seen.has(btn)) return;
      seen.add(btn);
      restyle(btn);
      new MutationObserver(function () { restyle(btn); })
        .observe(btn, { attributes: true, attributeFilter: ['style'] });
    });
  }

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
